import { render, staticRenderFns } from "./InplaceProgressBar.vue?vue&type=template&id=2b2e7f57&"
import script from "./InplaceProgressBar.vue?vue&type=script&lang=ts&"
export * from "./InplaceProgressBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports